import React from "react";
import { connect } from "react-redux";
import { getStaffInfo } from "../Actions/StaffManagementAPI";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { toast } from "react-toastify";

let searchData = {
  Name: '',
  PageNumber: 1,
  PageSize: 25
}
let user = JSON.parse(localStorage.getItem("currentUser"));

class StaffManagementAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      StaffInfo: {
        // shipName: "",
        name: "",
        phone1: "",
        phone2: "",
        email: "",
        address: "",
        createdBy: "",
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'SubBannerTitle', data: "Staff Management" });
  }

  SubmitData() {
    const { dispatch, history } = this.props;
    if (this.state.StaffInfo.email !== "") {
      let url2 = `${API.userExist}?Mail=${this.state.StaffInfo.email}&Id=${0}`
      axios.get(url2, {
        headers: {
          key: user.accessToken
        }
      })
        .then((response) => {
          if (response.data === true) {
            let url = `${API.PostStaff}`;
            axios.post(url, this.state.StaffInfo, {
              headers: {
                key: user.accessToken,
              }
            })
              .then((response) => {
                if(response.data!="User add Failed in identity server"){
                  toast.success("Added Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
                dispatch(getStaffInfo(searchData));
                history.goBack();
                dispatch({
                  type: "postStaffInfoSuccess",
                  data: response.data,
                })
              })
              .catch((error) => {
                dispatch({
                  type: "postStaffInfoFailure",
                  error: "ERROR"
                })
              })
          } else if (response.data === false) {
            swal('Error!', 'User already exist. Please change the email', 'warning');
            this.state.StaffInfo.email = "";
            this.setState({});
          }
          dispatch({
            type: 'getUserExistListSuccess',
            data: response.data
          })
        })
        .catch((error) => {
          dispatch({
            type: 'getUserExistListFailure',
            data: "error"
          })
        })
    } else {
      swal('Error!', 'Email is mandatory', 'warning');
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.StaffInfo[nodeName] = e.target.value;
    this.setState({});
  }

  render() {

    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="row search-filter-box">
                <div className="col-lg-12">
                  <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                      <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Basic Information</h5>
                    </div>
                  </div>
                  <div className="row search-filter-box">
                    {/* <div className="col-lg-4">
                      <label className="form-label">Ship Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="shipName"
                        placeholder="Ship Name"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.shipName}
                      ></input>
                    </div> */}
                    <div className="col-lg-4">
                      <label className="form-label">Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="Name"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.name}
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">Email</label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Email"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.email}
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">Phone 1</label>
                      <input
                        className="form-control"
                        type="text"
                        name="phone1"
                        placeholder="Phone 1"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.phone1}
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">Phone 2</label>
                      <input
                        className="form-control"
                        type="text"
                        name="phone2"
                        placeholder="Phone 2"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.phone2}
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">Address</label>
                      <textarea
                        className="form-control"
                        // type="textarea"
                        name="address"
                        placeholder="Address"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.StaffInfo.address}
                      ></textarea>
                    </div>
                  </div>
                  <div className="row py-3">
                    <div className="col-lg-12">
                      <div className="search-btn-col" style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit" onClick={() => this.SubmitData()}>Submit
                      </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button" onClick={() => this.CancelAdd()}> {" "} Cancel{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  CancelAdd = () => {
    this.props.history.push("/Home/Management/Staff");
  }
}
function mapStateToProps(state) {
  return {
    StaffInfoList: state.MasterScreenReducer.StaffInfoList
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StaffManagementAdd);
